module.exports = __webpack_public_path__ + "img/tesla_460.0b7aacf2.png";